import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-header-mysamples',
  templateUrl: './header-mysamples.component.html',
  styleUrl: './header-mysamples.component.scss',
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule]
})
export class HeaderMysamplesComponent {
  @Output() onSearch = new EventEmitter<string>();

  private search$ = new Subject<string>();
  private destroy$ = new Subject<void>();

  constructor() {
    this.search$
      .pipe(
        debounceTime(800),            
        distinctUntilChanged(),      
        takeUntil(this.destroy$)
      )
      .subscribe(value => this.onSearch.emit(value));
  }

  onChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.search$.next(value);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.search$.complete();
  }
}
